import { Outlet, useNavigate } from "react-router-dom";
import { Suspense } from "react";
import { useAuth } from "@/context/AuthContext";
import { useTenant } from "@/context/TenantContext";
import { tenantPath } from "@/lib/tenant";
import MerchantBrand from "./components/MerchantBrand";
import MerchantNavigation from "./components/MerchantNavigation";
import MerchantUserMenu from "./components/MerchantUserMenu";
import PlatformSupportBanner from "./components/PlatformSupportBanner";
import useSidebarCollapse from "./hooks/useSidebarCollapse";
import useWebsiteBranding from "../features/public_pages/hooks/useWebsiteBranding";
import { DealerPortalProvider, useDealerPortal } from "../features/crm/context/DealerPortalContext";
import NotificationInbox from "../features/notifications/components/NotificationInbox";
import JobsWindow from "../features/jobs/JobsWindow";
import { PageHeaderActionsProvider } from "../components/PageHeaderActions";
import PageLoader from "../components/PageLoader";
import { MERCHANT_CODE } from "../lib/tenant";
import "./appShell.css";

export default function MerchantLayout() {
  const { user } = useAuth();
  return user?.role === "sales_dealer" ? <DealerPortalProvider><MerchantLayoutContent /></DealerPortalProvider> : <MerchantLayoutContent />;
}

function MerchantLayoutContent() {
  const { user, logout } = useAuth();
  const dealerPortal = useDealerPortal();
  const { branding, modules, features, merchant } = useTenant();
  const websiteBrand = useWebsiteBranding();
  const navigate = useNavigate();
  const { collapsed, toggle } = useSidebarCollapse();
  const handleLogout = () => {
    const loginUrl = tenantPath("/login");
    logout();
    navigate(loginUrl, { replace: true });
  };
  return (
    <PageHeaderActionsProvider><div className="app-shell flex bg-background text-foreground">
      <aside className="app-shell-sidebar w-16 lg:w-64 shrink-0 border-r border-border bg-card flex flex-col">
        <MerchantBrand branding={branding} logoUrl={websiteBrand.logoUrl} merchantCode={websiteBrand.merchantCode}
          loading={websiteBrand.loading} error={websiteBrand.error} onRetry={websiteBrand.reload} />
        <MerchantNavigation role={user?.role} permissions={user?.permissions} modules={modules} features={features}
          dealerCapabilities={dealerPortal?.capabilities} pageUser={user} collapsed={collapsed} toggle={toggle}
          scrollScope={`merchant:${merchant?.id || merchant?.code_url || MERCHANT_CODE || window.location.hostname}:${user?.id || user?.role}`} />
        <MerchantUserMenu user={user} onLogout={handleLogout} />
      </aside>
      <main className="app-shell-main flex-1 min-w-0 min-h-0 flex flex-col overflow-hidden">
        <div className="shrink-0"><PlatformSupportBanner user={user} merchant={merchant} /></div>
        <div className="app-shell-viewport flex-1 min-w-0 min-h-0"><Suspense fallback={<PageLoader label="Loading page…" />}><Outlet /></Suspense></div>
      </main>
      <NotificationInbox />
      <JobsWindow />
    </div></PageHeaderActionsProvider>
  );
}
